import type { SxProps, Theme } from '@mui/material/styles';

export const pointerCursorSx: SxProps<Theme> = { cursor: 'pointer' };

export const primaryActionButtonSx: SxProps<Theme> = { minWidth: 140 };

export const addGroupButtonSx: SxProps<Theme> = { minWidth: 160 };

export const groupDividerSx: SxProps<Theme> = { mb: 2 };

export const flushControlLabelSx: SxProps<Theme> = { marginRight: 0 };

/** Pulls a date/time picker's DemoContainer up to the row's centre line. */
export const pickerRowOffsetSx: SxProps<Theme> = { marginTop: '-8px' };
